import React from 'react';

const DatesContext = React.createContext(null);

export default DatesContext;
